import SaveIcon from '@mui/icons-material/Save';
import { LoadingButton } from '@mui/lab';
import { Button } from '@mui/material';

import { ICoSettlementAgentObj } from '../../../../../types/SettlementAgent';
import { DocGenerationSource } from '../../../../constants/docGenerationSource';
import { constructPhoneObject } from '../../../../utils/helpers';

export interface IInviteSettlementActionsProps {
  isReviewing: boolean;
  orderType: string;
  setReviewStatus: (isReviewing: boolean) => void;
  isSending?: boolean;
  addCoSa: (values: any) => void;
  isListValid: boolean;
  confirmChecked: boolean;
  listPreview: Map<number, ICoSettlementAgentObj> | undefined;
  onClose?: () => void;
}

const InviteCoSettlementAgentActions = (props: any) => {
  const {
    isReviewing,
    isSending,
    orderType,
    setReviewStatus,
    addCoSa,
    isListValid,
    confirmChecked,
    listPreview,
    onClose,
  } = props;

  const sendInvites = () => {
    if (listPreview) {
      const resultArray = Array.from(listPreview.values());
      const formattedInvites = resultArray.map((e: any) => {
        return {
          FirstName: e.FirstName,
          Email: e.Email,
          LastName: e.LastName,
          PhoneNumber: constructPhoneObject(e.PhoneNumber),
        };
      });

      if (addCoSa) {
        addCoSa(formattedInvites);
      }
    }
  };

  return (
    <>
      {isReviewing ? (
        <>
          <Button onClick={() => setReviewStatus(false)} variant='text'>
            Back
          </Button>
          {isSending ? (
            <LoadingButton
              loading
              variant='contained'
              startIcon={<SaveIcon />}
              loadingPosition='start'>
              Sending Invitation{listPreview.size > 1 ? 's' : ''}
            </LoadingButton>
          ) : (
            <Button
              type='submit'
              onClick={sendInvites}
              variant='contained'
              color='primary'
              disabled={!confirmChecked}>
              {orderType === DocGenerationSource.FA
                ? 'Add Escrow Assistant'
                : 'Add Co-Settlement Agent'}
              {listPreview.size > 1 ? 's' : ''}
            </Button>
          )}
        </>
      ) : (
        <>
          <Button onClick={onClose} variant='text'>
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            disabled={!isListValid}
            onClick={() => setReviewStatus(true)}>
            Review
          </Button>
        </>
      )}
    </>
  );
};
export default InviteCoSettlementAgentActions;
